import type { FC } from 'react';

import { useGetIndicatorById } from '@/hooks/queries';

type Props = {
  indicatorId: string;
};

const Breadcrumb: FC<Props> = ({ indicatorId }) => {
  const { data } = useGetIndicatorById(indicatorId, !indicatorId);

  return <>{data?.indicator?.[0]?.Title || ''}</>;
};

export default Breadcrumb;
